const removeCommas = (value: string): string => {
  return value.replace(/,/g, '');
};

export default removeCommas;
